// extracted by mini-css-extract-plugin
export default {"backButton":"_09f7c072de _823a8ec2ed _3ddfa7775a cead4f5a5d"};